var o={arrowSizes:{L:9,M:7,S:5},backgroundColor:0,borderColor:100,text:"inherit",boxShadow:"S",paddingH:"10px",paddingV:"10px"};export{o as default};
